import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import _ from 'lodash';
import TagManager from 'react-gtm-module';

import { makeCanonicalTagObj, makeHreflangTagArr } from '@/utils';
import { getContent } from '@/services/api';
import {
  saveBeautyConsultationDiagnosisUserData,
  saveBeautyConsultationDiagnosis,
} from '@/redux/actions/beautyConsultationDiagnosis';
import { fetchHairDiagnosis } from '../../../redux/actions/hairDiagnosis';

import Slider from '../../../components/Slider/Slider';
import Placeholder from '../../../components/Placeholder';
import BreadCrumbMenu from '../../../components/BreadCrumbMenus/';
import { TABLET_P } from '../../../constants';
import NameSlide from '../../HairDiagnosisPage/Slides/Name';
import Question from './Slides/Question';

import {
  Wrapper,
  ContentWrapper,
  SliderWrapper,
  StartBtn,
  PrevBtn,
  NextBtn,
  FinishBtnWrapper,
  StartOverBtnFinish,
  FinishBtn,
  PlaceholderWrapper,
  StartOverBtnAbsolute,
  RightWrapper,
  SlideProgress,
} from './HairDiagnosisHomePage.style';

import { WHITE } from '../../../styles/variables.style';

const MAX_MLTIPLE_QUESTION_ANSWER_LENGTH = 3;

/**
 * 美容診断トップ
 */
class HairDiagnosisHomePage extends React.Component {
  constructor(props) {
    super(props);

    const { hairDiagnosis, locale, fetchHairDiagnosis } = this.props;
    if (!hairDiagnosis.title) {
      fetchHairDiagnosis(locale);
    }

    this.state = {
      currentSlide: 0,
      name: '',
      nameError: false,
      questions: [],
      q: [],
      // SEO 対策に必要なメタデータ
      siteOptionsMetaData: {},
      // 次へボタン押下制御用 (false: 活性、true: 非活性)
      isDisabledNextButton: true,
    };
  }

  componentWillMount() {
    const { locale } = this.props;

    if (locale) {
      // SEO 対策に必要なメタデータを取得する
      getContent({ contentType: 'siteOptionsMetaData', locale, slug: 'beauty-consultation' }).then(
        siteOptionsMetaData => this.setState({ siteOptionsMetaData })
      );
    }
  }

  componentDidMount() {
    const { hairDiagnosis, locale, fetchHairDiagnosis } = this.props;
    const { isFullFilled, title } = hairDiagnosis;

    // 画面描画前に行なったリクエストが失敗/データローディングが未完了、且つ、title がない場合
    if (!(isFullFilled && title)) {
      fetchHairDiagnosis(locale);
    }

    if (_.get(hairDiagnosis, 'questions')) {
      this.setQuestions(hairDiagnosis.questions);
    }
  }

  componentWillReceiveProps(nextProps) {
    const { hairDiagnosis } = nextProps;

    if (!this.props.hairDiagnosis.title && _.get(hairDiagnosis, 'questions')) {
      this.setQuestions(hairDiagnosis.questions);
    }
  }

  /**
   * 問診の設定を行う
   */
  setQuestions = q => {
    if (q) {
      const questions = [];
      q.map((question, i) => {
        if (Array.isArray(question)) {
          questions[i] = [];
          question.map(qq => questions[i].push(qq.multipleAnswer ? [] : {}));
        } else {
          questions[i] = question.multipleAnswer ? [] : {};
        }
        return null;
      });
      this.setState({
        q,
        questions,
      });
    }
  };

  /**
   * 「お名前」フォームの入力時に呼ばれる
   */
  handleUpdateName = ({ target }) => {
    this.setState({
      name: target.value,
      nameError: false,
      isDisabledNextButton: !(target.value && !target.value.match(/[~`!@#$%^&*()\-=+{}[\]\\|;:"<>,.?/]|[0-9]|^\s+$/g)),
    });
  };

  /**
   * 「やってみる」ボタン押下時に呼ばれる
   */
  handleNextQuestion = () => {
    const { currentSlide, questions, name } = this.state;
    const { copy, saveBeautyConsultationDiagnosisUserData } = this.props;

    const hasAnswer = Array.isArray(questions[currentSlide])
      ? questions[currentSlide].length > 0
      : !!questions[currentSlide];

    this.setState({ isDisabledNextButton: !hasAnswer });

    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });

    if (currentSlide === 0) {
      if (name.length < 2) {
        this.setState({ nameError: true });
      } else {
        saveBeautyConsultationDiagnosisUserData({ name });
        this.setState({ currentSlide: currentSlide + 1 });
      }
      TagManager.dataLayer({
        dataLayer: {
          event: 'bc_io',
          bc_display: copy.start_diagnosis,
        },
      });
    } else {
      const bcAnswer = this.isArray(questions[currentSlide - 1])
        ? questions[currentSlide - 1].map(({ text }) => text).join(',')
        : questions[currentSlide - 1].text;
      TagManager.dataLayer({
        dataLayer: {
          event: 'bc_io',
          bc_display: currentSlide,
          bc_answer: bcAnswer,
        },
      });

      this.setState({ currentSlide: currentSlide + 1 });
    }
  };

  changeDisabledNextButton() {
    const { currentSlide, questions } = this.state;
    const prevSlide = currentSlide - 1;

    this.setState({
      isDisabledNextButton: Array.isArray(questions[prevSlide - 1])
        ? questions[prevSlide - 1].length < 1
        : !questions[prevSlide - 1],
    });
  }

  /**
   * 問診 > 前へ戻るボタン押下時に呼ばれる
   */
  handlePrevQuestion = () => {
    this.changeDisabledNextButton();

    this.setState(({ currentSlide }) => ({ currentSlide: currentSlide - 1 }));
  };

  /**
   * 「やり直す」押下時に呼ばれる
   */
  handleStartOver = () => {
    this.setState({
      currentSlide: 0,
      questions: [],
      q: [],
    });

    const { hairDiagnosis } = this.props;
    if (_.get(hairDiagnosis, 'questions')) {
      this.setQuestions(hairDiagnosis.questions);
    }
  };

  handleAnswer = (answer, multiArrayIndex) => {
    const { questions, q } = this.state;

    if (answer) {
      this.setState({ isDisabledNextButton: false });
    }

    if (q[multiArrayIndex].multipleAnswer) {
      const selectedIndex = _.findIndex(questions[multiArrayIndex], item => item.slug === answer.slug);
      const selectedItem = _.find(questions[multiArrayIndex], item => _.get(item, 'slug'));

      if (!selectedItem && questions[multiArrayIndex].length === 0) {
        questions[multiArrayIndex].push(answer);
      } else {
        if (selectedIndex === -1) {
          if (questions[multiArrayIndex].length === MAX_MLTIPLE_QUESTION_ANSWER_LENGTH) return;
          questions[multiArrayIndex].push(answer);
        } else {
          questions[multiArrayIndex].splice(selectedIndex, 1);

          if (questions[multiArrayIndex].length < 1) {
            this.setState({ isDisabledNextButton: true });
          }
        }
      }
      this.setState({ questions });
    } else {
      questions[multiArrayIndex] = answer;
      this.setState({ questions });
    }
  };

  isArray = arr => Array.isArray(arr);

  isObject = o => o instanceof Object && !(o instanceof Array);

  isValidQuiz = () => {
    const { currentSlide, questions } = this.state;

    return currentSlide > questions.length - 1;
  };

  /**
   * 「診断結果を見る」ボタン押下時に呼ばれる
   */
  handleGetDiagnosis = () => {
    const { history, locale, saveBeautyConsultationDiagnosis } = this.props;
    const { questions, currentSlide } = this.state;

    saveBeautyConsultationDiagnosis(questions);
    history.push(`/${locale}/beauty-consultation/results`);

    const bcAnswer = this.isArray(questions[currentSlide - 1])
      ? questions[currentSlide - 1].map(({ text }) => text).join(',')
      : questions[currentSlide - 1].text;
    TagManager.dataLayer({
      dataLayer: {
        event: 'bc_io',
        bc_display: currentSlide,
        bc_answer: bcAnswer,
      },
    });
  };

  render() {
    const { copy, hairDiagnosis, locale, menuInfo } = this.props;
    const { currentSlide, name, questions, nameError, q, siteOptionsMetaData, isDisabledNextButton } = this.state;
    const isValidQuiz = this.isValidQuiz();

    return (
      <React.Fragment>
        {_.get(siteOptionsMetaData, 'metaData') && (
          <Helmet
            title={_.get(siteOptionsMetaData.metaData, 'title')}
            link={[
              makeCanonicalTagObj(locale, '/beauty-consultation'),
              ...makeHreflangTagArr(siteOptionsMetaData.metaData.region, '/beauty-consultation'),
            ]}
            meta={[
              {
                name: 'description',
                content: _.get(siteOptionsMetaData.metaData, 'description'),
              },
              {
                name: 'keyword',
                content: _.get(siteOptionsMetaData.metaData, 'keyword'),
              },
              // TODO: OGP タグは一旦保留 (2020年01月07日)
              // {
              //   property: 'og:url',
              //   content: _.get(siteOptionsMetaData.metaData, 'url'),
              // },
              // {
              //   property: 'og:type',
              //   content: _.get(siteOptionsMetaData.metaData, 'type'),
              // },
              // {
              //   property: 'og:title',
              //   content: _.get(siteOptionsMetaData.metaData, 'title'),
              // },
              // {
              //   property: 'og:image',
              //   content: _.get(siteOptionsMetaData.metaData, 'image.file.url'),
              // },
              // {
              //   property: 'og:description',
              //   content: _.get(siteOptionsMetaData.metaData, 'description'),
              // },
              // {
              //   property: 'og:site_name',
              //   content: _.get(siteOptionsMetaData.metaData, 'siteName'),
              // },
            ]}
          />
        )}
        <Wrapper>
          <ContentWrapper>
            {hairDiagnosis.title ? (
              <SliderWrapper>
                {currentSlide !== 0 ? (
                  <Slider
                    arrows
                    arrowLeft={
                      <PrevBtn onClick={this.handlePrevQuestion} style={{ display: !isValidQuiz ? 'block' : 'none' }} />
                    }
                    arrowRight={
                      <NextBtn
                        disabled={isDisabledNextButton}
                        onClick={this.handleNextQuestion}
                        style={{ display: !isValidQuiz ? 'block' : 'none' }}
                      />
                    }
                    autoHeight
                    currentSlide={currentSlide - 1}
                    dots={false}
                    keys={['CustomerInfoSlide', ...hairDiagnosis.questions.map(question => question.title)]}
                    options={{
                      duration: 800,
                      easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
                      loop: false,
                      perPage: 1,
                      draggable: false,
                    }}
                  >
                    {q.map((questionObj, i) => {
                      const question = questionObj;
                      if (!Array.isArray(question)) {
                        return (
                          <Question
                            copy={copy}
                            currentSlide={currentSlide}
                            key={question.entryId}
                            left={[0, 3, 8].indexOf(i) >= 0}
                            onAnswer={this.handleAnswer}
                            question={question}
                            selectedAnswer={questions[i]}
                            totalSlides={questions.length}
                            multiArrayIndex={i}
                          />
                        );
                      }
                      return (
                        <Question
                          copy={copy}
                          currentSlide={currentSlide}
                          key={question[0].entryId}
                          left={[0, 3, 8].indexOf(i) >= 0}
                          onAnswer={this.handleAnswer}
                          question={question}
                          selectedAnswer={questions[i]}
                          totalSlides={questions.length}
                          multiArrayIndex={i}
                        />
                      );
                    })}
                  </Slider>
                ) : (
                  <Fragment>
                    <NameSlide
                      copy={copy}
                      description={hairDiagnosis.description}
                      image={hairDiagnosis.introImages[0]}
                      name={name}
                      nameError={nameError}
                      onUpdateName={this.handleUpdateName}
                      title={hairDiagnosis.title}
                    />
                    <StartBtn
                      disabled={!name || name.match(/[~`!@#$%^&*()\-=+{}[\]\\|;:"<>,.?/]|[0-9]|^\s+$/g)}
                      onClick={this.handleNextQuestion}
                    >
                      {copy.start_diagnosis}
                    </StartBtn>
                  </Fragment>
                )}
                {isValidQuiz && (
                  <FinishBtnWrapper>
                    {/* 「やり直す」表示部分 */}
                    <StartOverBtnFinish onClick={this.handleStartOver}>
                      <span>{copy.start_over}</span>
                    </StartOverBtnFinish>
                    <RightWrapper>
                      <PrevBtn
                        onClick={this.handlePrevQuestion}
                        style={{
                          position: 'relative',
                          verticalAlign: 'bottom',
                          border: `1px solid ${WHITE}`,
                          bottom: 'auto',
                          right: 'auto',
                        }}
                      />
                      {/* 「診断結果を見る」表示部分 */}
                      <FinishBtn onClick={this.handleGetDiagnosis} disabled={isDisabledNextButton}>
                        {copy.get_diagnosis}
                      </FinishBtn>
                    </RightWrapper>
                  </FinishBtnWrapper>
                )}
                {!isValidQuiz &&
                  currentSlide >= 1 && (
                    <StartOverBtnAbsolute onClick={this.handleStartOver}>
                      <span>{copy.start_over}</span>
                    </StartOverBtnAbsolute>
                  )}
                {currentSlide !== 0 && (
                  <SlideProgress>
                    <span>{currentSlide}</span>/{questions.length}
                  </SlideProgress>
                )}
              </SliderWrapper>
            ) : (
              <PlaceholderWrapper>
                <Placeholder w="33.3%" h="100%" />
                <div style={{ width: '66.6%', padding: '3.5em 80px 3.5em 130px', backgroundColor: '#fff' }}>
                  <div style={{ marginTop: '36px', marginBottom: '36px' }}>
                    <Placeholder w="100%" h="86px" />
                  </div>
                  <div style={{ marginBottom: '70px' }}>
                    <Placeholder w="100%" h="81px" />
                  </div>
                  <Placeholder w="165px" h="20px" />
                </div>
              </PlaceholderWrapper>
            )}
          </ContentWrapper>
        </Wrapper>
        {!(locale && menuInfo && _.get(menuInfo, 'label') && _.get(hairDiagnosis, 'title')) ? (
          <Placeholder w="200px" h="24px" m={window.innerWidth > TABLET_P ? '0 0 20px 40px' : '0 0 20px 20px'} />
        ) : (
          <BreadCrumbMenu
            currentPath={`https://www.shiseido-professional.com/${locale}/beauty-consultation`}
            items={[
              {
                name: 'TOP',
                path: `/${locale}/`,
              },
              {
                name: 'FOR CUSTOMER',
                path: `/${locale}/for-customer`,
              },
              {
                name: hairDiagnosis.title.toUpperCase(),
                path: null,
              },
            ]}
          />
        )}
      </React.Fragment>
    );
  }
}

HairDiagnosisHomePage.defaultProps = {
  copy: {
    start_diagnosis: 'Start Diagnosis',
    start_over: 'Start Over',
    get_diagnosis: 'Get Diagnosis',
  },
  hairDiagnosis: {
    title: '',
    description: '',
    introImages: [{}],
  },
};

HairDiagnosisHomePage.propTypes = {
  locale: PropTypes.string.isRequired,
  hairDiagnosis: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    introImages: PropTypes.arrayOf(PropTypes.shape({})),
    questions: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  copy: PropTypes.shape({
    start_diagnosis: PropTypes.string,
    start_over: PropTypes.string,
    get_diagnosis: PropTypes.string,
  }),
  fetchHairDiagnosis: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  // ユーザーデータ保存用
  saveBeautyConsultationDiagnosisUserData: PropTypes.func.isRequired,
  // 回答内容保存用
  saveBeautyConsultationDiagnosis: PropTypes.func.isRequired,
  // 美容診断メニュー情報 (パンくずリストに必要な情報を含む)
  menuInfo: PropTypes.shape({}).isRequired,
};

const mapState = ({ siteOptions, hairDiagnosis, userSurvey, stylistDiagnosis, locale }) => ({
  copy: siteOptions.siteCopyHairDiagnosis,
  locale,
  // 問診内容取得
  hairDiagnosis,
  userSurvey,
  stylistDiagnosis,
  // 美容診断メニュー情報をキャッシュしておく
  menuInfo: siteOptions.menu ? siteOptions.menu[2] : {},
});

const mapDispatch = dispatch => ({
  fetchHairDiagnosis: locale => dispatch(fetchHairDiagnosis(locale)),
  saveBeautyConsultationDiagnosisUserData: data => dispatch(saveBeautyConsultationDiagnosisUserData(data)),
  saveBeautyConsultationDiagnosis: data => dispatch(saveBeautyConsultationDiagnosis(data)),
});

export default connect(mapState, mapDispatch)(HairDiagnosisHomePage);



// WEBPACK FOOTER //
// ./src/pages/HairDiagnosis/HairDiagnosisHomePage/HairDiagnosisHomePage.js